<script setup>
import { ref } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import { useAI } from 'dashboard/composables/useAI';
import NextButton from 'dashboard/components-next/button/Button.vue';

defineProps({
  isPrivateNote: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['replaceText']);
const { isAIIntegrationEnabled, draftMessage, processEvent, recordAnalytics } =
  useAI();
const initialMessage = ref('');
const isGeneratingReply = ref(false);

useKeyboardEvents({
  '$mod+KeyZ': {
    action: () => {
      if (initialMessage.value) {
        emit('replaceText', initialMessage.value);
        initialMessage.value = '';
      }
    },
    allowOnFocusedInput: true,
  },
});

const generateReply = async () => {
  if (isGeneratingReply.value) return;

  initialMessage.value = draftMessage.value;
  isGeneratingReply.value = true;

  try {
    const message = await processEvent('reply_suggestion');
    if (!message) return;

    recordAnalytics('REPLY_SUGGESTION');
    emit('replaceText', message);
  } finally {
    isGeneratingReply.value = false;
  }
};
</script>

<template>
  <div v-show="isAIIntegrationEnabled && !isPrivateNote" class="relative">
    <NextButton
      v-tooltip.top-end="$t('INTEGRATION_SETTINGS.OPEN_AI.AI_ASSIST')"
      :aria-label="$t('INTEGRATION_SETTINGS.OPEN_AI.AI_ASSIST')"
      icon="i-ph-magic-wand"
      :is-loading="isGeneratingReply"
      :disabled="isGeneratingReply"
      slate
      faded
      sm
      @click="generateReply"
    />
  </div>
</template>
